import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { leaderboardApi } from '../../../config/api-url';
import { Errors, LeaderboardService, DashboardService } from '../../../core';
import { FileService } from '../../../core/services/file.service';

@Component({
  selector: 'app-leaderboard-partner-tab',
  templateUrl: './leaderboard-partner-tab.component.html',
  styleUrls: ['./leaderboard-partner-tab.component.scss']
})
export class LeaderboardPartnerTabComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() userData: any;
  @Input() pamData: any = '';
  @Input() isActive: boolean = false;

  @ViewChild('rankTemplate') rankTemplate!: TemplateRef<any>;
  @ViewChild('bookingsTemplate') bookingsTemplate!: TemplateRef<any>;
  @ViewChild('earningsTemplate') earningsTemplate!: TemplateRef<any>;

  errors: Errors = { errors: {} };
  pamPeriodList: any = [];
  selectedQater: any;
  selectedpamQuaterData: any;
  countryList: any = [];
  countryListItems: any = [];
  selectedCountries: any = [];
  selectedCountry: any;
  beGeoIdList: any = [];
  selectedBegeoId: any = [];
  beGeoPage: number = 0;
  beGeoTotalElements: number = 0;
  beGeoLoading: boolean = false;
  partnerLeaderboardData: any;
  partnerLeaderboardColumns: any[] = [];
  isLoading: boolean = false;
  partnerLeaderboardPage: number = 1;
  partnerLeaderboardItemsPerPage: number = 5;

  constructor(
    private leaderboardService: LeaderboardService,
    private dashboardService: DashboardService,
    private fileService: FileService,
  ) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isActive'] && this.isActive) {
      this.partnerLeaderboardData = { notSelected: true };
      this.countryList = [];
      this.beGeoIdList = [];
      this.selectedCountries = [];
      this.selectedBegeoId = [];
      this.getperiodList();
      this.getCountryList();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => { this.initializePartnerLeaderboardTable(); });
  }

  getperiodList() {
    this.leaderboardService.getFiscalPamDropdownList().subscribe((data) => {
      if (data.length) {
        this.pamPeriodList = data;
        this.selectedQater = this.pamPeriodList[0];
        this.onChangePeriodList(this.selectedQater);
      }
    });
  }

  getCountryList() {
    this.dashboardService.getCountryListRequest(this.userData.username, this.pamData.theater).subscribe(data => {
      this.countryList = data['countryGroups'];
      this.countryListItems = this.countryList.map((country: any, index: number) => ({
        id: index,
        name: country
      }));
    });
  }

  onChangePeriodList(data: any) {
    this.selectedQater = data;
    this.selectedpamQuaterData = data;
  }

  onchangeCountry(data: any[]) {
    this.selectedCountries = data;
    this.selectedCountry = data.map((item: any) => item.name);
    this.beGeoPage = 0;
    this.beGeoTotalElements = 0;
    this.beGeoIdList = [];
    this.selectedBegeoId = [];
    if (data.length > 0) {
      this.fetchBeGeoIds();
    }
  }

  private fetchBeGeoIds(append: boolean = false): void {
    if (this.beGeoLoading) { return; }
    this.beGeoLoading = true;
    const paramReq: any = { username: this.userData.username, countries: this.selectedCountry };
    this.dashboardService.getBeGeoIdsRequest(paramReq, undefined, 10, this.beGeoPage).subscribe((beGeoData: any) => {
      this.beGeoTotalElements = beGeoData.totalElements || 0;
      const items = beGeoData.content || [];
      this.beGeoIdList = append ? this.beGeoIdList.concat(items) : items;
      this.beGeoLoading = false;
    }, () => {
      this.beGeoLoading = false;
    });
  }

  onBeGeoScrollEnd(): void {
    if (this.beGeoLoading || this.beGeoIdList.length >= this.beGeoTotalElements) { return; }
    this.beGeoPage++;
    this.fetchBeGeoIds(true);
  }

  onchangeBegeoId(data: any[]) {
    this.selectedBegeoId = data;
    if (this.selectedpamQuaterData) {
      this.getPartnerLeaderPerformenceList();
    }
  }

  getSelectedBeGeoIds(): string {
    if (!this.selectedBegeoId || this.selectedBegeoId.length === 0) {
      return '';
    }
    const ids = this.selectedBegeoId.map((item: any) => item.beGeoId || item);
    return ids.join(',');
  }

  getPartnerLeaderPerformenceList() {
    this.partnerLeaderboardPage = 1;
    this.fetchPartnerLeaderboardData(0);
  }

  fetchPartnerLeaderboardData(pageIndex: number): void {
    let queryparam = '';

    if (this.selectedpamQuaterData.fiscalYear != null && this.selectedpamQuaterData.fiscalQuarter != null) {
      queryparam = '&fiscalQuarter=' + this.selectedpamQuaterData.fiscalQuarter + '&fiscalYear=' + this.selectedpamQuaterData.fiscalYear;
    } else if (this.selectedpamQuaterData.fiscalYear != null && this.selectedpamQuaterData.fiscalQuarter == null) {
      queryparam = '&fiscalYear=' + this.selectedpamQuaterData.fiscalYear;
    } else if (this.selectedpamQuaterData.fiscalYear == null && this.selectedpamQuaterData.fiscalQuarter == null) {
      queryparam = '';
    }

    if (this.selectedBegeoId.length === 0) {
      this.partnerLeaderboardData = {
        partnerTab: 'PLD',
        data: { content: [], totalElements: 0 },
        begeoids: this.selectedBegeoId,
        selectedYear: queryparam,
        period: this.selectedQater.name
      };
      return;
    }

    const reqparam = '?beGeoIds=' + this.getSelectedBeGeoIds() + queryparam
      + '&period=' + this.selectedQater.name
      + '&excel=false'
      + '&page=' + pageIndex
      + '&size=' + this.partnerLeaderboardItemsPerPage;

    this.isLoading = true;
    this.leaderboardService.getPartnersLeaderboardData(reqparam).subscribe(response => {
      this.isLoading = false;
      let formattedData: any;
      if (Array.isArray(response)) {
        formattedData = { content: response, totalElements: response.length };
      } else if (response && response.content) {
        formattedData = response;
      } else if (response && response.entries) {
        formattedData = { content: response.entries.content || [], totalElements: response.entries.totalElements || 0 };
      } else {
        formattedData = { content: response || [], totalElements: response ? 1 : 0 };
      }

      this.partnerLeaderboardData = {
        partnerTab: 'PLD',
        data: formattedData,
        begeoids: this.selectedBegeoId,
        selectedYear: queryparam,
        period: this.selectedQater.name
      };
      this.initializePartnerLeaderboardTable();
    }, (err) => {
      this.isLoading = false;
      this.errors = err;
    });
  }

  initializePartnerLeaderboardTable() {
    const rankCol: any = { field: 'partnerRanking', header: 'Rank', align: 'center', isBold: true };
    const partnerNameCol: any = { field: 'partnerName', header: 'Partner Name' };
    const bookingsCol: any = { field: 'totalNetBookings', header: 'Total Net Bookings', align: 'right', isBold: true, prefix: '$' };
    const earningsCol: any = { field: 'totalPointsEarned', header: 'Total Points Earned', align: 'right', highlight: 'green', isBold: true };

    if (this.rankTemplate) { rankCol.cellTemplate = this.rankTemplate; }
    if (this.bookingsTemplate) { bookingsCol.cellTemplate = this.bookingsTemplate; }
    if (this.earningsTemplate) { earningsCol.cellTemplate = this.earningsTemplate; }

    this.partnerLeaderboardColumns = [
      rankCol,
      partnerNameCol,
      { field: 'beGeoId', header: 'Be Geo Id' },
      { field: 'country', header: 'Country' },
      bookingsCol,
      earningsCol
    ];
  }

  onPartnerLeaderboardPageChange(newPage: number) {
    this.partnerLeaderboardPage = newPage;
    this.fetchPartnerLeaderboardData(newPage - 1);
  }

  downloadClaimByExcel() {
    const fileName = 'Partners_LeaderboardData_Internal_Export_' + this.userData.company.id + '.xlsx';
    const fyear = this.selectedQater.fiscalYear == null ? '' : this.selectedQater.fiscalYear;
    const qatar = this.selectedQater.fiscalQuarter == null ? '' : this.selectedQater.fiscalQuarter;
    const param = '?beGeoIds=' + this.getSelectedBeGeoIds()
      + '&fiscalQuarter=' + qatar
      + '&fiscalYear=' + fyear
      + '&period=' + this.selectedQater.name
      + '&excel=true';
    const excelURL = leaderboardApi.partnersTotalPerformanceExport.replace('{param}', param);
    this.fileService.excelDownloadFile(excelURL, fileName);
  }

  splitData(value: any): string {
    const parseValue = parseFloat(value);
    if (isNaN(parseValue)) { return '0'; }
    return parseValue.toLocaleString('en-US');
  }
}
